import { CheckCircle, Tag } from 'lucide-react'
import type { NodeExecution } from 'sprites-types/api/v2/workflows'
import { getToolResultSchema } from 'sprites-types/workflow/tools/common'
import { gmailAddLabelToEmail } from 'sprites-types/workflow/tools/gmailAddLabelToEmail'
import {
  createWorkflowToolComponent,
  type WorkflowToolComponentProps,
} from '../shared/WorkflowToolComponent'
import { SchemaValidationError } from '../shared/safeParseToolResult'

function GmailAddLabelToEmailDisplayComponent({ nodeExecution }: WorkflowToolComponentProps) {
  const schema = getToolResultSchema(gmailAddLabelToEmail, nodeExecution.inputs)
  const parseResult = schema.safeParse(nodeExecution.outputs)

  if (!parseResult.success) {
    return <SchemaValidationError error={parseResult.error} nodeExecution={nodeExecution} />
  }

  const result = parseResult.data
  const inputs = nodeExecution.inputs

  const labelName = inputs.labelName || inputs.label || 'Label'
  const messageId = inputs.messageId || inputs.emailId || 'email'
  const emailCount = Array.isArray(result) ? result.length : 1

  return (
    <div className="rounded-3xl border border-gray-200/50 bg-white/70 text-black shadow-xl backdrop-blur-[8px]">
      <div className="flex items-center gap-4 px-4 py-3">
        <div className="flex-shrink-0">
          <div className="rounded-full bg-green-100 p-2">
            <CheckCircle className="h-5 w-5 text-green-600" />
          </div>
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-sm font-semibold text-gray-900">Label added successfully</div>
          <div className="text-xs text-gray-600">
            Added &quot;{labelName}&quot; to{' '}
            {emailCount > 1 ? `${emailCount} emails` : `email ${messageId}`}
          </div>
        </div>
        <div className="flex-shrink-0">
          <Tag className="h-5 w-5 text-gray-400" />
        </div>
      </div>
    </div>
  )
}

function downloadGmailAddLabel(_nodeExecution: NodeExecution): Promise<void> {
  return Promise.resolve()
}

function gmailAddLabelToMarkdown(nodeExecution: NodeExecution): string {
  const inputs = nodeExecution.inputs
  const labelName = inputs.labelName || inputs.label || 'Label'

  return `## Label Added Successfully

**Label:** ${labelName}

---
`
}

export const GmailAddLabelToEmailDisplay = createWorkflowToolComponent(
  GmailAddLabelToEmailDisplayComponent,
  downloadGmailAddLabel,
  gmailAddLabelToMarkdown
)
